import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect } from "react";
import { apiGetRecurringString } from "Root/api/apiCheckout";
import toastService from "Root/profile/toastService";
import { Loading } from "CheckoutComponents";
import styles from "./styles.module.css";
function PricingTable(props) {
    const [recurringDiscount, setRecurringDiscount] = useState("");
    useEffect(() => {
        const getRecurringString = async () => {
            try {
                const str = await apiGetRecurringString();
                setRecurringDiscount(str);
            }
            catch (e) {
                toastService.errorMessage("Something went wrong");
            }
        };
        getRecurringString();
    }, [props.lineItems]);
    return (_jsx(_Fragment, { children: props.lineItems === null ? (_jsx(Loading, {})) : (_jsx("div", { children: _jsx("table", { className: styles.table, children: _jsx("tbody", { className: styles.tbody, children: props.lineItems.map((item) => (_jsx(React.Fragment, { children: !props.isDuty && item.line_item_name === "Duty" ? (_jsx(_Fragment, {})) : (_jsxs(_Fragment, { children: [_jsxs("tr", { className: styles.tr, children: [_jsx("td", { className: styles.td, children: item.line_item_name }), _jsx("td", { className: `${styles.right} ${styles.td}`, children: item.line_item_price })] }, item.line_item_name), item.line_item_name === "Discount" && recurringDiscount !== "" && (_jsx("tr", { children: _jsx("td", { className: styles.recurringdis, children: recurringDiscount }) }))] })) }, item.line_item_name))) }) }) })) }));
}
export default PricingTable;
